import { AsyncState, Updater, errorAsyncState, loadingAsyncState } from "widgets-for-react";
import { GetEventPageByEventId, GetEventTemplateByEventId, getData } from "../../utils/api";
import { BreadcrumbProps } from "../sharedLayout/breadcrumbs";
import { SubmissionMessage } from "./eventForm.utils";
import { EventTemplate } from "../models/Events/Events";
import { EventPage } from "../cmsPage/cmsPageState";
import { getEventBreadcrumbs } from "../cmsPage/pages/event";
import { EventPageData } from "../cmsPage/sharepointPageApi/types/pageData";
import { transformEventPageData } from "../cmsPage/sharepointPageApi/transformers/pageDataToPage";

export interface EventFormState {
  eventData: AsyncState<EventTemplate>
  pageData: AsyncState<EventPage>
  submissionData?: SubmissionMessage
}

export const initialEventFormState = (eventId: string | null): EventFormState => ({
  eventData: eventId ? loadingAsyncState(() => getData<EventTemplate>(GetEventTemplateByEventId(eventId))) : errorAsyncState(404),
  pageData: eventId ? loadingAsyncState(() => getData<EventPage, EventPageData>(GetEventPageByEventId(eventId), transformEventPageData)) : errorAsyncState(404),
  submissionData: undefined
})

export const EventFormStateUpdaters = {
  updateEventData: (u: Updater<AsyncState<EventTemplate>>): Updater<EventFormState> => s0 => ({ ...s0, eventData: u(s0.eventData) }),
  updatePageData: (u: Updater<AsyncState<EventPage>>): Updater<EventFormState> => s0 => ({ ...s0, pageData: u(s0.pageData) }),
}

export const getBreadcrumbsEventForm = (pageData: EventPage): BreadcrumbProps => {
  const breadcrumbs = getEventBreadcrumbs(pageData)
  breadcrumbs.push({ title: "Inschrijven", url: "" })
  return { links: breadcrumbs }
}

